import { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Progress } from "@/components/ui/progress";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "../ui/item";

function StepProgress({
  currentStep,
  steps,
}: {
  currentStep: number;
  steps: {
    title: string;
    description: string;
    icon: LucideIcon;
  }[];
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Progression</CardTitle>

        <Progress
          className="mt-1 h-4"
          value={(currentStep / steps.length) * 100}
        />
        <p className="text-sm text-gray-600">
          Étape {currentStep} sur {steps.length}
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {steps.map((step, index) => (
            <Item
              key={index}
              className="group bg-muted data-[highlighted=true]:bg-primary data-[highlighted=true]:text-primary-foreground p-2"
              data-highlighted={currentStep > index}
            >
              <ItemMedia>
                <step.icon />
              </ItemMedia>
              <ItemContent className="gap-0">
                <ItemTitle>{step.title}</ItemTitle>
                <ItemDescription className="group-data-[highlighted=true]:text-white">
                  {step.description}
                </ItemDescription>
              </ItemContent>
            </Item>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export { StepProgress };
